import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { AppConstants, UrlConstants, LangConstants } from '../../constants';
import { StringUtils } from '../../utils';
import {CommonServices} from './api';
import {ActivatedRouteSnapshot} from '@angular/router';
import {EnvUtils} from '../../utils';

@Injectable()
export class AppServices {
    loginUser: any = {'id': '', 'name': ''};
    constructor (private titleService: Title,
                 private _commonServices: CommonServices) {
    }

    public setTitle(obj: string | Array<string>): void {
        const titleSeperator = ' | ';
        let title = '';
        if (typeof obj === 'string') {
            if (StringUtils.isNotEmpty(obj)) {
                title = obj + titleSeperator;
            }
        } else if (typeof obj === 'object') {
            for (const str of obj) {
                if (StringUtils.isNotEmpty(str)) {
                    title += str + titleSeperator;
                }
            }
        }
        title += AppConstants.appName;
        this.titleService.setTitle(title);
    }

    public getTitle(): string {
        return this.titleService.getTitle();
    }

    public getAppConstant(): object {
        return AppConstants;
    }

    public getUrls(): object {
        return UrlConstants;
    }

    public getLangs(): object {
        return LangConstants;
    }

    public getCurCmpnId(route: ActivatedRouteSnapshot): string {
        let curCmpnId = JSON.parse(decodeURIComponent(route.params['option'])).curCmpnId;

        if (global['loginUser'] !== undefined) {
            curCmpnId = global['loginUser'].curCmpnId;
        }

        return curCmpnId;
    }

    public getSession() {
        const token = EnvUtils.envCdToAccessToken();
        return this._commonServices.getSessionToPromise(token)
            .then(rslt => {
                const sesstionResult = rslt.json().data;
                if (sesstionResult && sesstionResult.portalUserId) {
                    const loginUserData = sesstionResult;
                    this.loginUser = {
                        userId: loginUserData.portalUserId,
                        siteCd: loginUserData.siteCd,
                        userEmail: loginUserData.emailId,
                        userNm: loginUserData.userNm,
                        blntCmpnId: loginUserData.blntCmpnId,
                        blntCmpnNm: loginUserData.blntCmpnNm,
                        curCmpnId: loginUserData.currPortalCmpnId,
                        userLangCd: loginUserData.currLangCd,
                        loginTmznCd: loginUserData.loginTmznCd,
                        loginTmznOfs: loginUserData.loginTmznOfs,
                        prflTmznCd: loginUserData.prflTmznCd,
                        prflTmznOfs: loginUserData.prflTmznOfs,
                        currTmznCdNm: loginUserData.currTmznCdNm,
                        tmznAplyTypeCd: loginUserData.tmznAplyTypeCd,
                        compCurCmpnId: loginUserData.currPortalCmpnId,
                        trialRemainDays : loginUserData.trialRemainDays,
                        trialExpireDt : loginUserData.trialExpireDt,
                        trialYn : loginUserData.trialYn,
                        chargeType: loginUserData.chargeType,
                        userDeptNm: loginUserData.userDeptNm,
                        useConcurrent: loginUserData.useConcurrent
                    };
                    global['loginUser'] = this.loginUser;

                    const userRole = {
                        userId: loginUserData.portalUserId,
                        userNm: loginUserData.userNm,
                        cmpnId: loginUserData.currPortalCmpnId,
                        roleCd: loginUserData.roleCd,
                        currLcnsTypeCd: loginUserData.currLcnsTypeCd,
                        rolePrms: loginUserData.rolePrms
                    };
                    global['userRole'] = userRole;
                }
                return rslt.json();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/app.services.ts